// import React from "react";
// import { WiHumidity, WiSunrise } from "react-icons/wi";
// import { TbSunset2 } from "react-icons/tb";
// import { FaWind } from "react-icons/fa";
// import { LiaTemperatureHighSolid } from "react-icons/lia";

// const WeatherCard = ({ weather }) => {
//   if (!weather) {
//     return <></>;
//   }

//   const {
//     name = "Unknown location",
//     country = "",
//     temp = "--",
//     feels_like = "--",
//     humidity = "--",
//     sunrise = "--",
//     sunset = "--",
//     speed = "--",
//     details = "No details available",
//     icon = "http://openweathermap.org/img/wn/01d@2x.png",
//     hourly = [],
//     daily = [],
//   } = weather;

//   const gradientBackground = {
//     background: "linear-gradient(0.25turn,#f3d78f ,#3f87a9,#3f87a9)",
//     color: "#fff",
//     borderBottom: "1px solid white",
//     borderRadius: "15px",
//     width: "100%",
//     height: "250px",
//   };

//   return (
//     <div
//       className="col-12 col-lg-10 text-center shadow mb-3 mx-auto"
//       style={gradientBackground}
//     >
//       <div
//         id="weatherCarousel"
//         className="carousel slide"
//         data-bs-ride="carousel"
//       >
//         <div className="carousel-inner">
//           <div className="carousel-item active">
//             <div className="card-body" style={gradientBackground}>
//               <div className="d-flex flex-column flex-md-row align-items-center mt-1 justify-content-around ">
//                 {/* <div>
//                   <img src={icon} alt="weather-icon" className="img-fluid" />
//                 </div> */}
//                 <div
//                   className="d-flex d-lg-block d-md-block flex-md-row align-items-center mt-1  justify-content-around"
//                   style={{ width: "80%" }}
//                 >
//                   <h2 className="h4 h-md-2">
//                     {name}, {country}
//                   </h2>
//                   <h1 className="display-6">{temp?.toFixed()}°C</h1>
//                   <p>{details}</p>
//                   <p className="d-none d-lg-block d-md-block">
//                     <FaWind className="fs-4 me-2" style={{ color: "white" }} />
//                     Wind Speed: <strong>{speed} m/s</strong>
//                   </p>
//                 </div>
//                 <div className="text-start d-flex d-lg-block d-md-block flex-md-row align-items-center mt-1 justify-content-around">
//                   <p className="d-none d-lg-block d-md-block text-center text-lg-start text-md-start">
//                     <LiaTemperatureHighSolid
//                       className="fs-4 me-2"
//                       style={{ color: "red" }}
//                     />
//                     Feels like: <strong>{feels_like?.toFixed()}°C</strong>
//                   </p>
//                   <p className="text-center text-lg-start text-md-start">
//                     <WiHumidity className="fs-4 me-0" /> Humidity:{" "}
//                     <strong>{humidity}%</strong>
//                   </p>
//                   <p className="text-center text-lg-start text-md-start">
//                     <WiSunrise
//                       style={{ color: "orange" }}
//                       className="fs-4 me-2"
//                     />
//                     Sunrise: <strong>{sunrise}</strong>
//                   </p>
//                   <p className="text-center text-lg-start text-md-start">
//                     <TbSunset2
//                       style={{ color: "orange" }}
//                       className="fs-4 me-2"
//                     />
//                     Sunset: <strong>{sunset}</strong>
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//           <div className="carousel-item">
//             <div className="card-footer p-5" style={gradientBackground}>
//               <h4 className="mt-2">Daily Forecast</h4>
//               <div className="d-flex justify-content-around">
//                 {daily.length > 0 ? (
//                   daily.slice(0, 5).map((day, index) => (
//                     <div key={index} className="text-center">
//                       <p>{day.title || "--"}</p>
//                       <img
//                         src={
//                           day.icon ||
//                           "http://openweathermap.org/img/wn/01d@2x.png"
//                         }
//                         alt="daily-icon"
//                         width="50"
//                       />
//                       <p>{day.temp || "--"}°C</p>
//                     </div>
//                   ))
//                 ) : (
//                   <p>No daily forecast available</p>
//                 )}
//               </div>
//             </div>
//           </div>
//           <div className="carousel-item">
//             <div className="card-footer p-5" style={gradientBackground}>
//               <h4 className="mt-2">Hourly Forecast</h4>
//               <div className="d-flex justify-content-around">
//                 {hourly.length > 0 ? (
//                   hourly.slice(0, 5).map((hour, index) => (
//                     <div key={index} className="text-center">
//                       <p>{hour.title || "--"}</p>
//                       <img
//                         src={
//                           hour.icon ||
//                           "http://openweathermap.org/img/wn/01d@2x.png"
//                         }
//                         alt="hourly-icon"
//                         width="50"
//                       />
//                       <p>{hour.temp || "--"}°C</p>
//                     </div>
//                   ))
//                 ) : (
//                   <p>No hourly forecast available</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//         <button
//           className="carousel-control-prev"
//           type="button"
//           data-bs-target="#weatherCarousel"
//           data-bs-slide="prev"
//         >
//           {/* <span
//             className="carousel-control-prev-icon"
//             aria-hidden="true"
//           ></span> */}
//           <span className="visually-hidden fs-6">Previous</span>
//         </button>
//         <button
//           className="carousel-control-next"
//           type="button"
//           data-bs-target="#weatherCarousel"
//           data-bs-slide="next"
//         >
//           {/* <span
//             className="carousel-control-next-icon"
//             aria-hidden="true"
//           ></span> */}
//           <span className="visually-hidden fs-6">Next</span>
//         </button>
//       </div>
//     </div>
//   );
// };

// export default WeatherCard;

import React from "react";
import { WiHumidity, WiSunrise } from "react-icons/wi";
import { TbSunset2 } from "react-icons/tb";
import { FaWind } from "react-icons/fa";
import { LiaTemperatureHighSolid } from "react-icons/lia";
import { useEffect } from "react";
import { useRef } from "react";

function getFullDayName(shortName) {
  const days = {
    Mon: "Monday",
    Tue: "Tuesday",
    Wed: "Wednesday",
    Thu: "Thursday",
    Fri: "Friday",
    Sat: "Saturday",
    Sun: "Sunday",
  };

  return days[shortName] || "Invalid day";
}

const WeatherCard = ({ weather }) => {
  // useEffect(() => {

  //   const carouselElement = document.querySelector("#weatherCarousel");
  //   if (carouselElement) {
  //     const carousel = new window.bootstrap.Carousel(carouselElement, {
  //       interval: 3000,
  //       ride: "carousel",
  //     });
  //     carousel.cycle();
  //   }
  // }, []);

  //   if (!weather) {
  //     return <></>;
  //   }

  const carouselRef = useRef(null);

  useEffect(() => {
    const el = carouselRef.current;
    if (!el) return;

    const items = Array.from(el.querySelectorAll(".carousel-item"));
    // Ensure one slide is active
    let idx = items.findIndex((item) => item.classList.contains("active"));
    if (idx < 0 && items.length) {
      items[0].classList.add("active");
      idx = 0;
    }

    const prevBtn = el.querySelector(".carousel-control-prev");
    const nextBtn = el.querySelector(".carousel-control-next");

    const showSlide = (newIndex) => {
      items[idx].classList.remove("active");
      items[newIndex].classList.add("active");
      idx = newIndex;
    };

    const rotateNext = () => showSlide((idx + 1) % items.length);

    // Auto‑rotate every 3s
    let intervalId = setInterval(rotateNext, 3000);

    // On manual nav, stop auto‑rotate and move slides
    const onPrev = (e) => {
      e.preventDefault();
      clearInterval(intervalId);
      showSlide((idx - 1 + items.length) % items.length);
    };
    const onNext = (e) => {
      e.preventDefault();
      clearInterval(intervalId);
      rotateNext();
    };

    prevBtn?.addEventListener("click", onPrev);
    nextBtn?.addEventListener("click", onNext);

    return () => {
      clearInterval(intervalId);
      prevBtn?.removeEventListener("click", onPrev);
      nextBtn?.removeEventListener("click", onNext);
    };
  }, []);

  if (!weather) return null;

  const {
    name = "Unknown location",
    country = "",
    temp = "--",
    feels_like = "--",
    humidity = "--",
    sunrise = "--",
    sunset = "--",
    speed = "--",
    details = "No details available",
    icon = "http://openweathermap.org/img/wn/01d@2x.png",
    daily = [],
    hourly = [],
  } = weather;

  const gradientBackground = {
    // borderBottom: "1px solid white",
    borderRadius: "15px",
    width: "100%",
    height: "300px",
  };

  return (
    <div
      className="col-12 col-lg-12 mx-auto rounded bg-gray-lt text-weight"
      style={gradientBackground}
    >
      {/* Bootstrap Carousel */}
      <div
        // id="weatherCarousel"
        // className="carousel slide"
        // data-bs-ride="carousel"
        // data-bs-interval="3000"
        ref={carouselRef}
        id="weatherCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        data-bs-interval="3000"
      >
        <div className="carousel-inner">
          {/* Slide 1: Current Weather */}
          <div className="carousel-item active">
            <div className="text-center">
              <div className="row justify-content-center mb-3 d-flex align-items-center">
                <div className="col-auto">
                  <h3 className="h3 mb-0">
                    {name}, {country}
                  </h3>
                  <div className="d-flex align-items-center">
                    <img
                      src={icon}
                      alt="weather-icon"
                      className="img-fluid"
                      style={{ height: "60px", marginRight: "25px" }}
                    />
                    <h1 className="display-5 mb-0 me-2">{temp?.toFixed()}°C</h1>
                  </div>
                  <p className="m-0">{details}</p>
                </div>
              </div>

              <div className="row text-center mb-3">
                <div className="col-4">
                  <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                    <WiHumidity className="me-2 text-info mb-1" size={30} />
                    <strong>Humidity</strong>
                    <p className="mb-0">{humidity}%</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                    <FaWind className="me-2 text-primary mb-1" size={30} />
                    <strong>Wind Speed</strong>
                    <p className="mb-0">{speed} m/s</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                    <LiaTemperatureHighSolid
                      className="me-2 text-danger mb-1"
                      size={30}
                    />
                    <strong>Feels Like</strong>
                    <p className="mb-0">{feels_like?.toFixed()}°C</p>
                  </div>
                </div>
              </div>

              <div className="row text-center mt-0">
                <div className="col-4">
                  <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                    <WiSunrise className="me-2 text-warning mb-1" size={30} />
                    <strong>Sunrise</strong>
                    <p className="mb-0">{sunrise}</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                    <TbSunset2 className="me-2 text-warning mb-1" size={30} />
                    <strong>Sunset</strong>
                    <p className="mb-0">{sunset}</p>
                  </div>
                </div>
                <div className="col-4">
                  <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                    <TbSunset2 className="me-2 text-warning mb-1" size={30} />
                    <strong>Temperature</strong>
                    <p className="mb-0">{temp?.toFixed()}°C</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Slide 2: Daily Forecast */}
          <div className="carousel-item">
            <div className="text-center">
              <h3 className="mb-4">Daily Forecast</h3>
              <div className="row g-5 justify-content-center">
                {daily.length > 0 ? (
                  daily.slice(0, 5).map((day, index) => (
                    <div key={index} className="col-4 text-center">
                      <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                        <p className="mb-0">{getFullDayName(day.title)}</p>
                        <img
                          src={
                            day.icon ||
                            "http://openweathermap.org/img/wn/01d@2x.png"
                          }
                          alt="daily-icon"
                          width="50"
                          className="p-0 mt-0 mb-0"
                        />
                        <p className="mb-0 mt-0">{day.temp || "--"}°C</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No daily forecast available</p>
                )}
              </div>
            </div>
          </div>

          {/* Slide 3: Hourly Forecast */}
          <div className="carousel-item">
            <div className="text-center">
              <h3 className="mb-4">Hourly Forecast</h3>
              <div className="row g-5 justify-content-center">
                {hourly.length > 0 ? (
                  hourly.slice(0, 5).map((hour, index) => (
                    <div key={index} className="col-4 text-center">
                      <div className="border rounded p-1 d-flex flex-column justify-content-center align-items-center h-100 bg-light">
                        <p className="mb-1">{hour.title || "--"}</p>
                        <img
                          src={
                            hour.icon ||
                            "http://openweathermap.org/img/wn/01d@2x.png"
                          }
                          alt="hourly-icon"
                          width="50"
                          className="mt-0 p-0 mb-0"
                        />
                        <p className="mt-0 mb-0">{hour.temp || "--"}°C</p>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No hourly forecast available</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* Carousel Controls */}
        <button
          className="carousel-control-prev"
          type="button"
          data-bs-target="#weatherCarousel"
          data-bs-slide="prev"
        >
          <span
            className="carousel-control-prev-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Previous</span>
        </button>
        <button
          className="carousel-control-next"
          type="button"
          data-bs-target="#weatherCarousel"
          data-bs-slide="next"
        >
          <span
            className="carousel-control-next-icon"
            aria-hidden="true"
          ></span>
          <span className="visually-hidden">Next</span>
        </button>
      </div>
    </div>
  );
};

export default WeatherCard;
